import axios from 'axios';
import { accessToken } from 'ccs-ui-components';
import { IService } from '../../../models';

/**
 * @method gets the Header object for api calls
 * @returns header object
 */
export const headerInstance = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${accessToken.value}`
});

/**
 * @method decryptServiceDetails
 * @param serviceName service name
 * @param data Json data to be decrypt
 * @returns Promise
 */
const decryptServiceDetails = async (serviceName: string, data: unknown) => axios.post(
  `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/decryption/${serviceName}`,
  data,
  {
    headers: headerInstance()
  }
);

/**
 * @method getDecryptedData
 * @description Gets the promises for data decryption either fulfilled or rejected
 * @param activeService : Service to be view
 * @returns promise resolved/rejected list
 */
export const getDecryptedData = async (activeService: IService) => {
  const data = await decryptServiceDetails(
      activeService.serviceName,
      { headerAttribute: activeService?.soapAttributes?.headersXML }
    );
  return data;
};
